module.exports = "/_next/static/images/app-store-fr-0aa8aaf1baf71983ba1f7e584a4d9b1d.svg";